export default "__VITE_ASSET__DUoGKbpe__"